const root = `td-register/generalPunish/`
const urls = {
  getDetail: root + 'detail',
  getList: root + 'page',
  remove: root + 'remove',
  add: root + 'save',
  update: root + 'update',
  existCseNo: root + 'existCseNo',
  existPunishDecisionNo: root + 'existPunishDecisionNo'
}

// 获取列表页数据
export const getList = obj => {
  return $http.get(urls.getList, obj)
}
// 删除列表中目标数据
export const remove = obj => {
  let ids = Array.isArray(obj) ? obj.map(z => z.id).join(',') : obj.id
  return $http.post(`${urls.remove}?ids=${ids}`)
}

export const add = obj => {
  return $http.post(urls.add, obj)
}
export const detail = id => {
  return $http.get(urls.detail, { id: id })
}

export const update = obj => {
  return $http.post(urls.update, obj)
}
export const existCseNo = obj => {
  return $http.get(urls.existCseNo, obj)
}
export const existPunishDecisionNo = obj => {
  return $http.get(urls.existPunishDecisionNo, obj)
}
export default {
  add,
  update,
  detail,
  getList,
  remove,
  existCseNo,
  existPunishDecisionNo
}
